export default {
    "确认": "Подтвердить",
    "取消": "Отменить",
    "选择语言": "Выберите язык",
    "切换语言成功": "Язык успешно изменен",
    "首页": "Главная",
    "申购": "Подписка",
    "团队": "Команда",
    "交易进行中,请勿进行其他操作": "Транзакция выполняется, не выполняйте другие операции",
    "资金管理": "УС",
    "资金明细": "Детали средств",
    "我的订单": "Мои заказы",
    "订单详情": "Детали заказа",
    "没有更多了": "Больше нет",
    "加载中": "Загрузка",
    "代币价格": "Цена токена",
    "收益概览": "Общие доходы",
    "申购收益": "Доходы от подписки",
    "分享收益": "Доходы от приглашений",
    "官方网站": "Оф. сайт",
    "官网": "Оф. сайт",
    "电报": "Телеграм",
    "推特": "Твиттер",
    "白皮书": "Белая книга",
    "申购金额": "Сумма подписки",
    "请输入入金金额": "Введите сумму депозита",
    "快捷申购": "Быстрая подписка",
    "申购比例": "Процент подписки",
    "赠币数量": "Количество подарочных токенов",
    "立即申购": "Подписаться сейчас",
    "更多": "Больше",
    "订单": "Заказ",
    "分红中": "ВПД",
    "已完成": "Завершено",
    "累计分红": "Всего дивидендов",
    "申购信息": "Информация о подписке",
    "兑换数量": "Количество для обмена",
    "赠币数量": "Количество подарочных токенов",
    "开始时间": "Время начала",
    "提现成功": "Вывод средств успешен",
    "确认": "Подтвердить",
    "订单编号": "Номер заказа",
    "团队数据总览": "Общие данные команды",
    "我的推广链接": "Моя реферальная ссылка",
    "复制": "Копировать",
    "分享此链接邀请好友加入团队，获取推广奖励": "Поделитесь этой ссылкой, чтобы пригласить друзей в команду и получить награду за приглашение",
    "团队业绩": "Результаты команды",
    "当前等级": "Текущий уровень",
    "今日收益": "Доходы сегодня",
    "申购收益": "Доходы от подписки",
    "分享收益": "Доходы от приглашений",
    "团队用户": "Пользователи команды",
    "有效团队": "Действительная команда",
    "有效用户": "Действительные пользователи",
    "无效团队": "Недействительная команда",
    "直推用户": "Прямые приглашения",
    "有效直推": "Действительные прямые приглашения",
    "无效直推": "Недействительные прямые приглашения",
    "资产余额数据概览": "Общие данные об остатках активов",
    "提现": "Вывод средств",
    "选中币种": "Выбранная валюта",
    "请输入入金金额": "Введите сумму депозита",
    "提现数量": "Количество для вывода",
    "确认提现": "Подтвердить вывод",
    "资金明细": "Детали средств",
    "分红收入": "Доходы от дивидендов",
    "直推奖励": "НЗПИ",
    "团队奖励": "Награда за команду",
    "申购金额": "Сумма подписки",
    "兑换数量": "Количество для обмена",
    "赠币数量": "Количество подарочных токенов",
    "开始时间": "Время начала",
    "立即申购": "Подписаться сейчас",
    "提现成功": "Вывод средств успешен",
    "确认": "Подтвердить",
    "全部": "Все",
    "收入": "Доходы",
    "支出": "Расходы",
    "请输入正确的金额": "Введите правильную сумму",
    "申购成功": "Подписка успешна",
    "申购失败": "Подписка не удалась",
    "提现成功": "Вывод средств успешен",
    "提现失败": "Вывод средств не удался",
    "提现信息": "Информация о выводе",
    "提现币种": "Валюта для вывода",
    "提现数量": "Количество для вывода",
    "请选择币种": "Выберите валюту",
    "钱包余额不足": "Недостаточно средств в кошельке",
    "余额不足": "Недостаточно средств",
    "提现手续费": "Комиссия за снятие средств",
    "间推奖励": "Награда за косвенное приглашение",
    "团队奖励": "Командная награда",
    "提现失败退还": "Возврат при неудачном снятии средств",
    "ido申购": "Подписка на IDO",
    "ido申购赠送": "Подарок за подписку на IDO",
    "链式去中心化全球点火网络": "Цепочная децентрализованная глобальная сеть зажигания",
    "长期价值": "Долгосрочная ценность",
    "智能涌现": "Интеллектуальное возникновение",
    "协议永生": "Бессмертие протокола",
    "立即进入": "Войти сразу",
    "大区累计业绩": "Общий результат крупной области",
    "小区累计业绩": "Общий результат мелкой области",
    "复制成功": "Копирование завершено успешно",
    "复制失败": "Копирование не удалось",
    "暂无数据": "Данных нет",
    "CUSD支付比例": "CUSD процент",
    "支付CUSD数量": "CUSD количество",
    "算力红利": "CUSD процент",
    "当DeFi遇上自主型DAO闲置算力共享": "Когда DeFi встретится с自主ным DAO, который использует висящую мощность",   
    "全民节点分红智能涌现": "Интеллектуальное возникновение",
    "闲置算力共享·全民节点分红": "Висящая мощность и общая дивиденда",

}
